"use client"
import { clsx } from "@/src/utils/clsx"
import React, { useEffect, useState } from "react"
import { type CallToActionBlockData } from "."

type CallToActionProps = {
    data: CallToActionBlockData
    children?: React.ReactNode
}

const getTextColorClass = (textColorWhite: boolean) =>
    textColorWhite ? "md:text-white text-main-black" : "text-main-black"

export default function CallToActionModuleWrapper({ data, children }: CallToActionProps) {
    const { image, textColorWhite = false, backgroundColor } = data
    const textColorClass = getTextColorClass(textColorWhite)

    const [dynamicStyles, setDynamicStyles] = useState<React.CSSProperties>({})

    useEffect(() => {
        function updateStyle() {
            const mdBreakpoint = 968 // Tailwind's 'md' breakpoint
            if (window.innerWidth >= mdBreakpoint) {
                setDynamicStyles({
                    backgroundColor: backgroundColor?.hex || "#F2F3F0"
                })
            } else {
                setDynamicStyles({})
            }
        }

        window.addEventListener("resize", updateStyle)
        updateStyle() // Initialize style on component mount

        return () => window.removeEventListener("resize", updateStyle)
    }, [backgroundColor])

    return (
        <section className="py-32 md:py-80">
            <div
                style={dynamicStyles}
                className={clsx(
                    !image?.fullWidth && "grid grid-cols-2 md:p-24",
                    image?.fullWidth && "md:aspect-2/1",
                    "relative mx-15 gap-x-15 gap-y-32 overflow-hidden md:mx-24 md:gap-x-24 md:gap-y-24", // gap-x-15  md:gap-x-24
                    textColorClass
                )}
            >
                {children}
            </div>
        </section>
    )
}
